import { TimePeriodDTO } from '../dtoTypes'
import { TimePeriod } from '../types'

export const adaptTimePeriodDTO = (periodDTO: TimePeriodDTO): TimePeriod => {
    return {
        start: periodDTO?.start ?? null,
        end: periodDTO?.end ?? null,
    }
}
